import SparkIcon from '@/assets/icons/spark.svg?url'
import { Trans } from '@/components'
import { Instance } from '@/models/instance'

import { InstanceAccess } from './InstanceAccess'

export function InstanceAccessWithPublicIP({
  instance,
  onUpdate,
}: {
  instance: Instance
  onUpdate?: () => void
}) {
  return (
    <div className="bg-panel-gray-100 rounded-lg p-4">
      <div className="flex items-center gap-x-1 mb-4">
        <div className="text-tertiary t-xs">Public IP Information</div>
        <div className="px-2 py-0.5 border border-neutral-200 bg-neutral-50 rounded-full flex items-center justify-center gap-x-1">
          <img src={SparkIcon} alt="spark" className="w-4 h-4" />
          <div className="t-xs bg-gradient-to-r from-[#717784] via-[#B1B4BB] to-[#717784] bg-clip-text text-transparent">
            <Trans i18nKey="create.bindPublicIpTechnicalPreview">Technical Preview</Trans>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <div className="grid grid-cols-4 gap-4">
          <div className="flex flex-col gap-y-1">
            <div className="text-secondary t-xs">ID</div>
            <div className="t-sm">{instance.nats?.[0].net.netResID}</div>
          </div>
          <div className="flex flex-col gap-y-1">
            <div className="text-secondary t-xs">Public IP Address</div>
            <div className="t-sm">{instance.nats?.[0].net.networkName}</div>
          </div>
        </div>
      </div>

      <InstanceAccess instance={instance} onUpdate={onUpdate} bgClassName="bg-white" />
    </div>
  )
}
